import React from "react"
import Paper from "../../ui/Paper"
import Input from "../../ui/Input"
import { useDispatch, useSelector } from "react-redux"
import {
  addRoleToUserAccount,
  selectUserAccountsById,
  selectUserAccountsRoles,
} from "./slice"
import LoadingSpinner, { Backdrop } from "../../ui/LoadingSpinner"
import styled from "styled-components"
import Label from "../../ui/Label"
import Select from "../../ui/Select"
import FormError from "../../ui/FormError"
import FormGroup from "../../ui/FormGroup"
import Button from "../../ui/Button"
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import ErrorMsg from "../../ui/ErrorMsg"
import PropTypes from "prop-types"
import { slideFromRight } from "../../ui/animations"
import ActionsFooter from "../../ui/ActionsFooter"

const Panel = styled(Paper)`
  padding: 2rem;
  overflow-y: auto;
  width: 25vw;
  min-width: 20rem;
  max-width: 40rem;
  animation: 0.3s ${slideFromRight} ease-out;
`
const FormContainer = styled.div``

/**
 * The form validator
 */
const schema = yup
  .object({
    role: yup.string().max(100).required(),
    ctx: yup.string().max(150),
  })
  .required()

/**
 * Add a role to a User account
 *
 * @param handleCancel
 * @returns {JSX.Element}
 * @constructor
 */
const AddRole = ({ id, handleCancel }) => {
  const dispatch = useDispatch()
  const roles = useSelector(selectUserAccountsRoles)
  const accountsByID = useSelector(selectUserAccountsById)
  const account = accountsByID[id]
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  })
  const onSubmit = (data) => {
    dispatch(addRoleToUserAccount({ ...data, id }))
      .unwrap()
      .then(() => {
        handleCancel()
      })
  }

  return (
    <Panel>
      <h2>Add role</h2>
      {account?._saveStatus === "updating" && (
        <Backdrop>
          <LoadingSpinner />
        </Backdrop>
      )}
      {account?._saveStatus == "rejected" && (
        <ErrorMsg
          msg={account._errorMessage || "an error occurred adding a role"}
          showIcon={true}
        />
      )}
      <FormContainer>
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormGroup>
            <Label htmlFor="role">Role:</Label>
            <Select {...register("role")} autoFocus>
              {Object.values(roles).map((r, i) => (
                <option key={i} value={r.name}>
                  {r.name}
                </option>
              ))}
            </Select>
          </FormGroup>
          <FormGroup>
            <Label htmlFor="ctx">Organisation (URI):</Label>
            <Input type="text" {...register("ctx")} />
            <FormError>{errors.ctx?.message}</FormError>
          </FormGroup>
          <ActionsFooter>
            {handleCancel && <Button onClick={handleCancel}>Close</Button>}
            <Button type="submit" active>
              Submit
            </Button>
          </ActionsFooter>
        </form>
      </FormContainer>
    </Panel>
  )
}

AddRole.propTypes = {
  id: PropTypes.string, // email of the account
  handleCancel: PropTypes.func, // Cancel add role
}
export default AddRole
